import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { map, pluck, shareReplay, switchMap } from 'rxjs/operators';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { FooterService } from 'src/app/service/footer/footer.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { GenericLinkComponent } from '../generic-link/generic-link.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, GenericLinkComponent, AsyncPipe],
})
export class FooterComponent implements OnInit, OnDestroy {
  styleClass$: Observable<string> = this.componentData.data$.pipe(map((d) => d.styleClass));
  breakPointSize: any;
  breakPointSizeSubscription: Subscription;

  private breakAfterIndex$ = combineLatest([this.activeCountry$, this.activeLanguage$, this.breakpoint$]).pipe(
    switchMap(([activeCountry, activeLanguage, breakpoint]) =>
      this.footerService.getBreakAfterIndex(activeCountry, activeLanguage, breakpoint)
    ),
    shareReplay(1) // <— prevents re-triggering on new emissions
  );

  footerData$: Observable<any> = this.componentData.data$.pipe(
    pluck('navigationNode', 'children'),
    switchMap((footerData) =>
      combineLatest([of(footerData.map((footer: any) => footer?.children[0]?.entries[0] || {})), this.breakAfterIndex$])
    ),
    map(([links, breakAfterIndex]) => ({ links, breakAfterIndex }))
  );

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private footerService: FooterService,
    private breakpointService: BreakpointService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.breakPointSizeSubscription = this.breakpoint$.subscribe((data: any) => {
      this.breakPointSize = data;
    });
  }

  get activeCountry$(): Observable<string> {
    return this.countryService.getActive();
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  get breakpoint$(): Observable<BREAKPOINT> {
    return this.breakpointService.breakpoint$;
  }
  ngOnDestroy(): void {
    this.breakPointSizeSubscription?.unsubscribe();
  }
}
